import { Component, OnInit, OnDestroy, ViewChild, AfterViewInit} from '@angular/core';
import { AppService } from '../../../app.service';
import { Subscription } from 'rxjs';
import { Router, NavigationEnd } from '@angular/router';
import { MenuService } from '../../../service/menu.service';
import { ShoppingCartService } from '../../../service/shopping-cart.service';
import { WishlistService } from '../../../service/wishlist.service';
import { AuthService } from '../../../service/auth/auth.service';
import { NovedadService } from '../../../service/novedad.service';

@Component({
  selector: 'app-top-menu',
  templateUrl: './top-menu.component.html',
  styleUrls: ['./top-menu.component.scss'],
})
export class TopMenuComponent implements OnInit, OnDestroy, AfterViewInit {
  @ViewChild('sidenav') sidenav: any;
  private currency:any;
  public flags = [
    { name:'English', image: 'assets/images/flags/gb.svg' },
    { name:'German', image: 'assets/images/flags/de.svg' },
    { name:'French', image: 'assets/images/flags/fr.svg' },
    { name:'Russian', image: 'assets/images/flags/ru.svg' },
    { name:'Turkish', image: 'assets/images/flags/tr.svg' }
  ]
  public flag:any;

  private subscription: Subscription;

  constructor(
      private appService:AppService,
      private menuService:MenuService,
      private authService: AuthService,
      private router: Router,
      private shoppingCartService: ShoppingCartService,
      private wishlistService: WishlistService,
      private novedadService: NovedadService
    ) { }  

  ngOnInit() {    
    this.flag = this.flags[0];
  }

  /**
   * @author Frank Edward Daza González
   * @version 2018-11-06
   */
  ngOnDestroy() {
    if (this.subscription !== null && this.subscription !== undefined)
      this.subscription.unsubscribe();
  }

  ngAfterViewInit() {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        if(this.sidenav){
          this.sidenav.close();
        }
      }
    });
  }

  public changeCurrency(currency){
    this.currency = currency;
  }

  public changeLang(flag){
    this.flag = flag;
  }

  /**
   * Verifica si un usuario se ha autenticado, y tiene un token válido.
   * 
   * @author Frank Edward Daza González
   * @version 2018-11-06
   */
  isAuthenticate() {
    return this.authService.isAuthenticate();
  }

  /**
   * Cierra la sesión del cliente.
   * 
   * @author Frank Edward Daza González
   * @version 2018-11-06
   */
  onLogout() {
    this.authService.logout();
    this.router.navigate(['/']);
    this.menuService.loadMenu(null);
    
    this.shoppingCartService.carrito.carrId = null;
    this.shoppingCartService.carrito.tercId_SicaTercero = null;
    this.shoppingCartService.carrito.costoEnvio = null;
    this.shoppingCartService.carrito.estado = null;
    this.shoppingCartService.carrito.fechaCreacion = null;
    this.shoppingCartService.carrito.fechaInicio = null;
    this.shoppingCartService.carrito.fechaModificacion = null;
    this.shoppingCartService.carrito.totalItems = 0;
    this.shoppingCartService.carrito.usuarioCreador = null;
    this.shoppingCartService.carrito.usuarioModificador = null;
    this.shoppingCartService.carrito.valorIva = null;
    this.shoppingCartService.carrito.valorTotal = 0;
    this.shoppingCartService.carrito.listSicaDetalleCarrito = [];
    this.shoppingCartService.setCarrito(this.shoppingCartService.carrito);
  }

  /**
   * Retorna el nombre del usuario de la sesión.
   *  
   * @author Frank Edward Daza González
   * @version 2018-11-08
   */
  getUserSessionName(): string {
    
    return this.authService.getUser().iss;
  }

  /**
   * Retorna el correo del usuario de la sesión.
   *  
   * @author Andrés Felipe Vargas López
   * @version 2018-11-14
   */
  getUserSessionMail(): string {
    return this.authService.getUser().sub;
  }

}
